'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_POLLING_INTERVAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isNull = require('lodash/isNull');

var _isNull2 = _interopRequireDefault(_isNull);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _constants = require('./constants');

var componentEvents = _interopRequireWildcard(_constants);

var _DebugManager = require('../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dmInstance = _DebugManager2.default.dmInstance;


var UNAUTHENTICATED = 'UNAUTHENTICATED';
var EventStatusEnum = componentEvents.EventStatusEnum,
    DestinationTypeEnum = componentEvents.DestinationTypeEnum;
var ARCHIVED = EventStatusEnum.ARCHIVED,
    STAGED = EventStatusEnum.STAGED,
    COMPLETED = EventStatusEnum.COMPLETED;
var DEFAULT_POLLING_INTERVAL = exports.DEFAULT_POLLING_INTERVAL = 5000;

var HTTPEvent = function () {
  function HTTPEvent(dataHandler, errorHandler, config) {
    var _this = this;

    _classCallCheck(this, HTTPEvent);

    this.close = function () {
      clearInterval(_this.pollIntervalReference);
      _this.pollIntervalReference = 0;
      _this.nextIds = {
        viewer: null,
        producer: null
      };
      _this.reset();
    };

    this.reset = function () {
      _this.eventList = [];
    };

    this.pollHandler = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventId, accountId, componentEventHost) {
        var previewToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var producerEvents, viewerEvents;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                producerEvents = [];
                viewerEvents = [];
                _context.prev = 2;

                if (!_this.config.isProducer) {
                  _context.next = 10;
                  break;
                }

                _context.next = 6;
                return _this.getComponentEvents(DestinationTypeEnum.PRODUCER, eventId, accountId, componentEventHost);

              case 6:
                producerEvents = _context.sent;

                _this.dataHandler(producerEvents);
                _context.next = 14;
                break;

              case 10:
                _context.next = 12;
                return _this.getComponentEvents(DestinationTypeEnum.VIEWER, eventId, accountId, componentEventHost, previewToken);

              case 12:
                viewerEvents = _context.sent;

                _this.dataHandler(viewerEvents, true);

              case 14:
                _this.retryCounter = 0;
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](2);

                console.error('[HTTPEvent] Problem getting component events while polling', _context.t0);

                //Need to force re-authentication when receiving a 401
                if (_context.t0.response && _context.t0.response.status == 401) {
                  _this.close();
                  _this.store.dispatch({
                    type: UNAUTHENTICATED
                  });
                } else {
                  _this.retryCounter++;
                  if (_this.retryCounter >= _this.maxRetriesForPolling) {
                    console.error('[HTTPEvent] Giving up on polling due to network issues');
                    _this.errorHandler(_context.t0);
                  }
                }

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 17]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    this.catchUp = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventId, accountId, componentEventHost) {
        var previewToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var _eventList;

        var status = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '00:00:00';
        var newEvents, retry, type, playback, producerEvents, viewerEvents;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.areValidParams(eventId, accountId, componentEventHost)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('\n        invalid:\n        eventId: ' + eventId + '\n        accountId: ' + accountId + '\n        componentEventHost: ' + componentEventHost + '\n      ');

              case 2:
                newEvents = [];
                retry = false;
                _context2.prev = 4;

                // if eventstatus = archived, then call a different endpoint for catch up events
                type = DestinationTypeEnum.VIEWER;
                playback = void 0;


                if (!(0, _isNull2.default)(status) && (status === ARCHIVED || status === COMPLETED || status === STAGED)) {
                  type = DestinationTypeEnum.ARCHIVED;
                  if (status === ARCHIVED) {
                    playback = true;
                  } else {
                    playback = false;
                  }
                }

                if (!_this.config.isProducer) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 11;
                return _this.getComponentEvents(DestinationTypeEnum.PRODUCER, eventId, accountId, componentEventHost, null);

              case 11:
                producerEvents = _context2.sent;

                dmInstance.log('[HTTPEvent.catchUp] New component events received on catch up. length: ' + producerEvents.length);
                newEvents.push.apply(newEvents, _toConsumableArray(producerEvents));

                if (!(0, _isEmpty2.default)(producerEvents)) {
                  retry = true;
                }
                _context2.next = 23;
                break;

              case 17:
                _context2.next = 19;
                return _this.getComponentEvents(type, eventId, accountId, componentEventHost, previewToken, playback, offset);

              case 19:
                viewerEvents = _context2.sent;

                newEvents.push.apply(newEvents, _toConsumableArray(viewerEvents));
                dmInstance.log('[HTTPEvent.catchUp] New component events received on catch up. length: ' + viewerEvents.length);
                if (!(0, _isEmpty2.default)(viewerEvents)) {
                  if (!(0, _isNull2.default)(status) && (status === ARCHIVED || status === COMPLETED || status === STAGED)) {
                    retry = false; // for archived playback, all events prior to event start are returned. set retry=false here to prevent loop. 
                  } else {
                    retry = true;
                  }
                }

              case 23:
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2['catch'](4);
                throw _context2.t0;

              case 28:

                (_eventList = _this.eventList).push.apply(_eventList, newEvents);

                if (!retry) {
                  _context2.next = 31;
                  break;
                }

                return _context2.abrupt('return', _this.catchUp(eventId, accountId, componentEventHost, previewToken, status));

              case 31:
                return _context2.abrupt('return', [].concat(_toConsumableArray(_this.eventList)));

              case 32:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[4, 25]]);
      }));

      return function (_x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      };
    }();

    this.getComponentEvents = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type) {
        var eventId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.eventId;
        var accountId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.accountId;
        var componentEventHost = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this.componentEventHost;
        var previewToken = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var playback = arguments[5];
        var offset = arguments[6];
        var paramData, params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this.areValidParams(eventId, accountId, componentEventHost)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('\n        invalid:\n        eventId: ' + eventId + '\n        accountId: ' + accountId + '\n        componentEventHost: ' + componentEventHost + '\n      ');

              case 2:
                paramData = {};

                // 'archived' type needs anyBand to equal false in order to avoid returning inBand events
                // 'producer' type endpoint actually ignores the anyBand parameter.
                // TODO should refactor to make cleaner paths for each 'type'

                if (type === DestinationTypeEnum.VIEWER) {
                  paramData.anyBand = true;
                }

                !(0, _isNull2.default)(playback) ? paramData.playback = playback : null;

                if (!(0, _isNull2.default)(_this.nextIds[type])) {
                  paramData.next = _this.nextIds[type];
                }

                if (previewToken) {
                  paramData.token = previewToken;
                }

                paramData.startTimeOffset = offset;

                params = _qs2.default.stringify(paramData);
                _context3.prev = 9;
                _context3.next = 12;
                return HTTPEvent.localAxios.get(componentEventHost + '/account/' + accountId + '/event/' + eventId + '/componentEvent/' + type + '/key?' + params, {
                  headers: { 'Content-Type': 'application/json' },
                  withCredentials: true
                });

              case 12:
                res = _context3.sent;

                if (!((0, _isUndefined2.default)(res.data.pagination) || (0, _isUndefined2.default)(res.data.pagination.next))) {
                  _context3.next = 15;
                  break;
                }

                return _context3.abrupt('return', res.data.data);

              case 15:

                _this.nextIds[type] = res.data.pagination.next;
                return _context3.abrupt('return', res.data.data);

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3['catch'](9);
                throw _context3.t0;

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[9, 19]]);
      }));

      return function (_x11) {
        return _ref3.apply(this, arguments);
      };
    }();

    this.postEvent = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(metadata, data) {
        var componentEventHost = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.componentEventHost;
        var inBand = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var destinationType, accountId, eventId, res, postUrl;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                destinationType = metadata.destinationType, accountId = metadata.accountId, eventId = metadata.eventId;

                if (_this.areValidParams(eventId, accountId, componentEventHost)) {
                  _context4.next = 3;
                  break;
                }

                throw new Error('\n        invalid:\n        eventId: ' + eventId + '\n        accountId: ' + accountId + '\n        componentEventHost: ' + componentEventHost + '\n      ');

              case 3:
                res = void 0;
                postUrl = componentEventHost + '/account/' + accountId + '/event/' + eventId + '/componentEvent' + (inBand ? '/inBand' : '');
                _context4.prev = 5;
                _context4.next = 8;
                return (0, _axios2.default)(postUrl, {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  withCredentials: true,
                  params: {
                    destination: destinationType === 'audience' ? DestinationTypeEnum.VIEWER : destinationType
                  },
                  data: data
                });

              case 8:
                res = _context4.sent;
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);
                return _context4.abrupt('return', new Error(_context4.t0));

              case 14:
                return _context4.abrupt('return', res);

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this, [[5, 11]]);
      }));

      return function (_x16, _x17) {
        return _ref4.apply(this, arguments);
      };
    }();

    this.dataHandler = dataHandler || this.missingHandler;
    this.errorHandler = errorHandler || this.missingHandler;

    // retry counter and max for determining when to give up on polling when there are network issues
    this.retryCounter = 0;
    this.maxRetriesForPolling = 5;

    this.pollIntervalReference = 0;
    this.accountId = null;
    this.eventId = null;
    this.componentEventHost = null;
    this.store = null;

    this.nextIds = {
      viewer: null,
      producer: null
    };

    this.eventList = [];
    this.config = _extends({
      isProducer: true,
      pollingInterval: DEFAULT_POLLING_INTERVAL
    }, config);
  }

  // local instance of axios created because we don't want to use the retry interceptor when polling


  _createClass(HTTPEvent, [{
    key: 'setStore',
    value: function setStore(store) {
      this.store = store;
    }
  }, {
    key: 'missingHandler',
    value: function missingHandler() {
      throw new Error('Missing handler function!');
    }
  }, {
    key: 'areValidParams',
    value: function areValidParams() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      return !params.some(function (param) {
        return (0, _isNull2.default)(param) || (0, _isEmpty2.default)(param) || (0, _isUndefined2.default)(param);
      });
    }
  }, {
    key: 'open',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(accountId, eventId, componentEventHost) {
        var previewToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var status = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var lastInBandEventId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
        var type;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                // if a lastinbandeventId is given, use that as the 'next' parameter when beginning polling.
                // This is usually the case when beginning polling after a video stream interruption.
                if (lastInBandEventId) {
                  type = this.config.isProducer ? DestinationTypeEnum.PRODUCER : DestinationTypeEnum.VIEWER;

                  this.nextIds[type] = lastInBandEventId;
                }

                if (!this.pollIntervalReference) {
                  _context5.next = 4;
                  break;
                }

                console.warn('[HTTPEvent] Polling is already active, you must clear the previous poll to start HTTP polling.');
                return _context5.abrupt('return', false);

              case 4:
                if (this.areValidParams(eventId, accountId, componentEventHost)) {
                  _context5.next = 6;
                  break;
                }

                throw new Error('\n        invalid:\n        eventId: ' + eventId + '\n        accountId: ' + accountId + '\n        componentEventHost: ' + componentEventHost + '\n      ');

              case 6:

                this.accountId = accountId;
                this.eventId = eventId;
                this.componentEventHost = componentEventHost;

                //don't poll for COMPLETED, STAGED, or ARCHIVED

                if (!(!(0, _isNull2.default)(status) && !(status === ARCHIVED || status === COMPLETED || status === STAGED))) {
                  _context5.next = 16;
                  break;
                }

                console.log('[HTTPEvent] Setting up component event polling with pollingInterval: ' + this.config.pollingInterval);
                _context5.next = 13;
                return this.pollHandler(eventId, accountId, componentEventHost, previewToken);

              case 13:
                this.pollIntervalReference = setInterval(this.pollHandler.bind(this, eventId, accountId, componentEventHost, previewToken), this.config.pollingInterval);
                _context5.next = 17;
                break;

              case 16:
                console.log("[HTTPEvent] polling not used");

              case 17:
                return _context5.abrupt('return', true);

              case 18:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function open(_x20, _x21, _x22) {
        return _ref5.apply(this, arguments);
      }

      return open;
    }()
  }]);

  return HTTPEvent;
}();

HTTPEvent.localAxios = _axios2.default.create({
  timeout: 10001,
  responseType: 'json'
});
exports.default = HTTPEvent;